import result from './Result';

export default result
export { result as Base }
